
<header class="header">
  <h1 class="title">
    Todo List!
  </h1>
  <nav>
    <a routerLink="/">Home</a> |
    <a routerLink="/about">Sobre</a>
  </nav>
</header>
